import { ArrowUpRight } from "lucide-react";
import { PARTNERS } from "@/lib/marketing";

const WORKS_WITH = [
  { name: "WSafe AI", href: "https://wsafe.ai", desc: "AI hazard detection on existing cameras." },
  { name: "HazardLoop", href: "https://hazardloop.com", desc: "Corrective action tracking and verified closeout." },
  { name: "InductIQ", href: "https://inductiq.ai", desc: "Induction/training verification and incident reporting." },
];

export const WorksWith = () => (
  <section id="works-with" className="max-w-7xl mx-auto px-6 py-20" data-testid="works-with">
    <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#275C3F]">Works with</span>
    <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight mt-3">Part of one WorkSafeAgent platform</h2>
    <div className="grid md:grid-cols-3 gap-4 mt-10">
      {WORKS_WITH.map((w) => (
        <a key={w.name} href={w.href} data-testid={`works-with-${w.name.toLowerCase().replace(/\s+/g, "-")}`}
           className="group bg-white border border-[#DCE3DD] rounded-sm p-6 hover:border-[#275C3F]/50 transition-colors duration-200">
          <div className="flex items-center justify-between">
            <h3 className="font-display text-xl font-semibold">{w.name}</h3>
            <ArrowUpRight className="h-4 w-4 text-[#4B5950] group-hover:text-[#275C3F]" />
          </div>
          <p className="text-[#4B5950] mt-2 text-sm leading-relaxed">{w.desc}</p>
        </a>
      ))}
    </div>
  </section>
);

export const Partners = () => (
  <section className="border-t border-[#DCE3DD] bg-[#F8FAF8]" data-testid="partners">
    <div className="max-w-7xl mx-auto px-6 py-12">
      <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#4B5950]">Partners</span>
      <ul className="flex flex-wrap gap-3 mt-5">
        {PARTNERS.map((p, i) => (
          <li key={p} data-testid={`partner-${i}`} className="text-sm font-medium text-[#121A14] border border-[#DCE3DD] bg-white px-4 py-2 rounded-sm">{p}</li>
        ))}
      </ul>
    </div>
  </section>
);
